import { render, staticRenderFns } from "./ReleaseLog.vue?vue&type=template&id=c9cc2cea&scoped=true&"
import script from "./ReleaseLog.vue?vue&type=script&lang=js&"
export * from "./ReleaseLog.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseLog.vue?vue&type=style&index=0&id=c9cc2cea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9cc2cea",
  null
  
)

export default component.exports